import { useState } from "react";
import { useExamConfigManage } from "./hooks/useExamConfigManage";
import Card from "../../components/Card/Card";
import Loader from "../../components/Loader/Loader";
import Modal from "../../components/Modal/Modal";
import ExamConfigurationForm from "./ExamConfigurationForm";
import ExamConfigurationGuideline from "./ExamConfigurationGuideline";
import Button from "../../components/Button/Button";

const ExamConfigManage = () => {
  const [info, setInfo] = useState(false);

  const {
    state,
    student_ids,
    studentSubjectWise,
    gradeSchemeID,
    grade_scheme_type,

    handleChange,
    handleChangeTraits,
    handleChangeTraitsScheme,
    handleInputChange,
    handleSubmit,

    program_id,
    scoreSchemesData,

    onSubjectSelect,
    onSubjectRemove,
    changeStudentSubjectWise,

    selectAllStudent,
    addNewRow,
    clickOnDelete,
    setState,
  } = useExamConfigManage();

  const back = () => window.history.back();
  let path = window.location.pathname;

  return (
    <Card
      componentName={state.id ? path.includes("clone") ? "Clone ExamConfig" : "Update ExamConfig" : "Add ExamConfig"}
      back={back}
      freezed={<Button variant={state.freezed ? "primary" : "secondary"}
        onClick={() => setState((prevState) =>
          ({ ...prevState, freezed: !prevState.freezed }))}>
        {!state.freezed ? "Freeze" : "Unfreeze"}
      </Button>}
    >
      <Modal isOpen={info} onClose={() => setInfo(false)} title="Info">
        <ExamConfigurationGuideline />
      </Modal>

      {state.loader ? (
        <Loader />
      ) : (
        <ExamConfigurationForm
          submitHandler={handleSubmit}
          changeHandler={handleChange}
          changeTraitHandler={handleChangeTraits}
          handleChangeTraitsScheme={handleChangeTraitsScheme}
          selectAllStudent={selectAllStudent}
          inputChangeHandler={handleInputChange}
          addRow={addNewRow}
          clickOnDelete={clickOnDelete}
          data={state}
          program_id={program_id}
          scoreSchemesData={scoreSchemesData}
          gradeSchemeID={gradeSchemeID}
          grade_scheme_type={grade_scheme_type}
          student_ids={student_ids}
          subjectData={state.subjectData}
          onSubjectSelect={onSubjectSelect}
          onSubjectRemove={onSubjectRemove}
          selectedSubjects={state.selectedSubjects}
          studentSubjectWise={studentSubjectWise}
          changeStudentSubjectWise={changeStudentSubjectWise}
        />
      )}
    </Card>
  );
};

export default ExamConfigManage;
